import { Inline, Skeleton, Stack } from '@omnipresentgroup/design-system';
import {
  InputFieldSkeleton,
  RadioFieldSkeleton,
} from '@omnipresentgroup/shared';

export const FormSkeleton = () => {
  return (
    <Stack gap="32">
      <Stack gap="16">
        <RadioFieldSkeleton numberOfOptions={3} />
        {[1, 2].map((_, index) => (
          <InputFieldSkeleton key={index} />
        ))}
        <InputFieldSkeleton withHelper />
        {[1, 2, 3, 4].map((_, index) => (
          <InputFieldSkeleton key={index} />
        ))}
      </Stack>
      <Inline justify="flex-end">
        <Skeleton width={80} height={40} />
      </Inline>
    </Stack>
  );
};
